export enum ScoreType {
  "coinbaseKYC" = "coinbase-kyc",
}
